<template>
  <div class="pagination">
    <div class="page-box">
      <span @click="handleChange(1)" class="button bold btn-left">首页</span>
      <el-pagination
        prev-text="上一页"
        next-text="下一页"
        :total="pageData.total"
        :page-count="maxPageNumber"
        :page-size="pageData.pageSize"
        :current-page="pageData.currentPage"
        layout="prev,pager, next, total,slot"
        @current-change="handleChange"
      >
        <div style="display:inline-block">
          <span class="text">跳转到</span>
          <input type="text" class="goto" v-model.number="goto" @keyup.enter="handlerGoTo" />
          <el-button class="gobtn" @click="handlerGoTo">
            <span class="bold" style="line-height: 12px;">GO</span>
          </el-button>
        </div>
      </el-pagination>
    </div>

    <slot />
    <div class="page-right-aside">
      <slot name="right-aside"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'common-page',
  props: {
    pageData: {
      type: Object,
      default() {
        return {
          total: 20,
          pageSize: 20,
          currentPage: 1,
        }
      },
    },
  },

  data() {
    return {
      goto: '',
    }
  },
  computed: {
    maxPageNumber() {
      const { total, pageSize } = this.pageData
      return Math.floor(total / pageSize) + 1
    },
  },

  methods: {
    // 当页码切换时
    handleChange(pageNum) {
      const { currentPage } = this.pageData
      if (pageNum !== currentPage) {
        this.$emit('change', pageNum)
      }
    },
    // 跳转到指定页面
    handlerGoTo() {
      const { goto, maxPageNumber } = this
      if (!goto || isNaN(Number(goto))) return

      if (goto >= maxPageNumber) {
        this.goto = maxPageNumber
      }

      this.handleChange(this.goto)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
